import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  link: {
    color: theme.palette.primary.main,
  },
  emphasize: {
    fontWeight: 500,
  }
}))
